"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEEDS_CATEGORY_LABEL_COPY = exports.REVIEW_ACTION_COPY = exports.FILTERED_TOTALS_LEAD_COPY = exports.STRIP_EMPTY_MONTH_COPY = exports.STRIP_EMPTY_PERIOD_COPY = exports.STRIP_THIS_MONTH_COPY = exports.STRIP_PAY_PERIOD_COPY = exports.STRIP_OVER_COPY = exports.STRIP_LEFT_COPY = exports.STRIP_INCOME_COPY = exports.STRIP_SPENT_COPY = void 0;
exports.stripWindowLabel = stripWindowLabel;
exports.stripEmptyPeriodLine = stripEmptyPeriodLine;
exports.uncategorisedShareLine = uncategorisedShareLine;
exports.uncategorisedSpentLine = uncategorisedSpentLine;
exports.reviewRowLine = reviewRowLine;
/**
 * The Transactions page's period strip (Anthony's Transactions redesign, Phase 1,
 * approved by Paul 2026-10-08). One copy for both clients (rule 17; agreed with mobile
 * in writing, report -98). Keys name the slot; `*_COPY` names keep them in the copy
 * inventory.
 *
 * The strip's figures are the DASHBOARD REMAINDER's (`GET /dashboard/remainder/`):
 * Spent = total_expenses, Income = total_income, Left = remainder. It never computes a
 * second "Left". Its window is the current pay period, or the calendar month when no
 * paycheck is detected (FP-062). A stale window (R5) withholds the figures with
 * `STALE_FIGURE` and says why with `staleDataLine`, from `staleDataCopy`.
 */
const apiDates_1 = require("./apiDates");
exports.STRIP_SPENT_COPY = "Spent";
exports.STRIP_INCOME_COPY = "Income";
exports.STRIP_LEFT_COPY = "Left";
/** Beside a negative Left, so overspending is never told by colour alone. */
exports.STRIP_OVER_COPY = "over";
/** The strip's heading for a detected pay period; its dates follow it. */
exports.STRIP_PAY_PERIOD_COPY = "This pay period";
/** The window when no paycheck is detected (FP-062: no invented pay period). */
exports.STRIP_THIS_MONTH_COPY = "This month";
// "Nothing counted", not "No transactions": the remainder counts only categorised
// spending (needs/wants/savings), so a window whose rows all need a category reads $0
// while those rows sit in the list below (found on team.sparse, 2026-10-08).
exports.STRIP_EMPTY_PERIOD_COPY = "Nothing counted in this pay period yet.";
exports.STRIP_EMPTY_MONTH_COPY = "Nothing counted this month yet.";
/** "Sep 12 – Sep 25" for a detected pay period, "This month" otherwise. */
function stripWindowLabel(start, end, detected) {
    return detected
        ? `${(0, apiDates_1.shortApiDate)(start)} – ${(0, apiDates_1.shortApiDate)(end)}`
        : exports.STRIP_THIS_MONTH_COPY;
}
/** Why the strip shows "—": nothing in its window is counted yet. */
function stripEmptyPeriodLine(detected) {
    return detected ? exports.STRIP_EMPTY_PERIOD_COPY : exports.STRIP_EMPTY_MONTH_COPY;
}
/** The one line that keeps filtered totals reachable once the strip replaces the
 *  summary cards (web: FP-144's cards, conflict C1 in report -98). Both clients. */
exports.FILTERED_TOTALS_LEAD_COPY = "Filtered:";
/**
 * FP-182 (Paul, 2026-10-09; announced to mobile under rule 17 the same day): the dollar
 * line names its window, so it can't be read against the review banner's all-time
 * count ("53 transactions need a category"): "$55.37 of this period's spending needs a
 * category", or "…of this month's spending…" on Budgets. "of …'s spending", not "spent
 * this period": "spent" read as the verb. `amountText` is each client's formatted money.
 */
function uncategorisedShareLine(amountText, window) {
    return `${amountText} of this ${window}'s spending needs a category`;
}
/**
 * @deprecated FP-182: use `uncategorisedShareLine`, which names the window. Kept so
 * mobile's merged callers keep compiling until its half of the extension switches;
 * delete it then.
 *
 * FP-176: the part of Spent that still needs a category, under Spent wherever Spent is
 * shown ("$115.37 needs a category"), with REVIEW_ACTION_COPY leading to the review
 * list. `amountText` is each client's own formatted money (the sign rule is per client).
 */
function uncategorisedSpentLine(amountText) {
    return `${amountText} needs a category`;
}
/** The review row: web's replacement for CAT-013's "Needs Review" tile, and the
 *  wording mobile ADOPTS in its Phase 1 in place of its UnknownBanner ("N uncategorized
 *  transactions"), so do not restore that. Callers hide the row at 0. */
exports.REVIEW_ACTION_COPY = "Review";
/**
 * FP-176 extension (Paul, 2026-10-09; mobile's rule-17 approval the same day): the
 * label for spending that still needs a category, as its own line wherever categories
 * are listed (FA §4, Insights, the dashboard row, the Budgets month view). Sentence
 * case on purpose: it is a state, not a bucket. Never a plan bucket either: keep it
 * out of allocation maths.
 */
exports.NEEDS_CATEGORY_LABEL_COPY = "Needs a category";
function reviewRowLine(count) {
    return `${count} transaction${count === 1 ? "" : "s"} need${count === 1 ? "s" : ""} a category`;
}
//# sourceMappingURL=transactionStripCopy.js.map